import { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import templatesApi from "api/landlord/templates";

export const useVerificationTemplatesController = (perPage: number = 999) => {
  const [currentPage, setCurrentPage] = useState(1);

  const defaultTemplateQuery = useQuery({
    queryKey: ["DEFAULT_TEMPLATE"],
    queryFn: () => templatesApi.getDefaultTemplate()
  });

  const templatesQuery = useQuery({
    queryKey: ["TEMPLATES", currentPage, perPage],
    queryFn: () =>
      templatesApi.getTemplates({ page: currentPage, per_page: perPage }),
    placeholderData: keepPreviousData
  });

  const verificationSchemasQuery = useQuery({
    queryKey: ["VERIFICATION_SCHEMAS"],
    queryFn: () => templatesApi.getVerificationSchemas()
  });

  return {
    defaultTemplate: defaultTemplateQuery.data?.verification_template,
    verificationSchemas: verificationSchemasQuery.data?.verification_schemas,
    templates: templatesQuery.data?.items,
    isLoading: templatesQuery.isLoading,
    isFetching: templatesQuery.isFetching,
    refetchTemplates: templatesQuery.refetch,
    templatesData: templatesQuery.data,
    setCurrentPage
  };
};
